import { ZomentumEntity, TableQueryFilter } from "../common";
import { EmailThreadRecipients } from "../Others/EmailThread";
import { MergeTagVariable } from "../Documents";
import { UserData } from "../Users";

export interface EmailTemplateFileDetails {
	file_id: string;
	file_name: string;
	file_size?: number;
}
export interface SystemEmailTemplateContent {
	readonly heading?: string;
	readonly button_text?: string;
	readonly end_salutation?: string;
}

export class EmailTemplateRequest {
	name = "";
	subject = "";
	body = "";
	file_details = new Array<EmailTemplateFileDetails>();
	custom_template_type: CustomTemplateType | null = null;
	system_template_info?: SystemEmailTemplateContent | null = null;
}

export class EmailTemplate extends ZomentumEntity {
	id = "";
	name = "";
	subject = "";
	body = "";
	file_details?: EmailTemplateFileDetails[] =
		new Array<EmailTemplateFileDetails>();
	merge_tags_system_variables: MergeTagVariable[] =
		new Array<MergeTagVariable>();
	user: UserData = new UserData();
	created: Date = new Date();
	updated: Date = new Date();
	custom_template_type: CustomTemplateType | null = null;
	deleted = false;
	defaultTemplate?: boolean = false;
	system_template_info?: SystemEmailTemplateContent | null = null;
}

export class EmailTemplatesDrawerFormValues {
	title = "";
	subject = "";
	body = "";
}

export enum CustomTemplateType {
	SendDocument = "send_document",
	DocumentReminder = "document_reminder",
	SignDocument = "sign_document",
	DocumentExpired = "document_expired",
	DocumentWon = "document_won",
	Comment = "comment"
}

export class EmailTemplatesResponse {
	filtered_count_map = null;
	data: EmailTemplate[] = new Array<EmailTemplate>();
}

export interface EntitySelectionFormProps {
	client: string;
	opportunity: string;
	documents: string;
	recipients: string[];
}

export class EntitySelectionFormValues {
	client = "";
	opportunity: string | null = null;
	documents: string | null = null;
	recipients: string[] = new Array<string>();
}

export class SelectedEntityValues {
	client = "";
	opportunity: string | null = null;
	documents: string | null = null;
	recipients: EmailThreadRecipients[] = new Array<EmailThreadRecipients>();
}

export class UseTemplateValues {
	subject = "";
	body = "";
	attachments = new Array<EmailTemplateFileDetails>();
	entity_details: SelectedEntityValues = new SelectedEntityValues();
}

export class EmailTemplateGetRequest {
	filters: TableQueryFilter[];
	keywords: string | null;
	constructor(filters: TableQueryFilter[], keywords: string | null) {
		this.filters = filters;
		this.keywords = keywords;
	}
}

export class PreviewEmailTemplateRequest {
	from: EmailThreadRecipients | null = null;
	subject = "";
	body = "";
	should_replace_with_empty_string = true;
	document_id = "";
	template_type: CustomTemplateType = CustomTemplateType.SendDocument;
}

export interface PreviewSystemEmailTemplate {
	from: {
		email: string;
		name: string;
	};
	subject: string;
	body: string;
	to: [];
}
